import React from 'react';

export const AppFooter = (props) => {

    return (
        <div className="layout-footer">
            © Chambre des Métiers du G-D du Luxembourg <a style={{ color: "#efb600", cursor: "pointer", marginLeft: "10px" }} rel="noopener noreferrer" href={`https://www.cdm.lu/mentions-legales`} target="_blank">Aspects légaux</a>
        </div>
    );
}
